import { NetworkName } from './network'

export const contractAddresses: Record<NetworkName, ContractAddress> = {
  mainnet: {
    stabilityFactory: '',
    stabilityRouter: '',
    stabilityController: '',
    oracle: '',
    factory: '',
    pilotPool: '',
    pilotGateway: '',
  },
  testnet: {
    stabilityFactory: '',
    stabilityRouter: '',
    stabilityController: '',
    factory: '',
    oracle: 'terra18y7gs3j57qplhymq9jxflqq302gac62pupts9x',
    pilotPool: 'terra1wujerrqmmksnej2d8tf3ys2dn9qe7reds453st',
    pilotGateway: 'terra1nq33yqhjjm958hga6c4p7wla2gz6yh75skm2s5',
  },
}

export const contractCode: Record<NetworkName, CodeID> = {
  mainnet: {
    interestModel: {
      default: 0,
      linear: 0,
      tripleSlope: 0,
      quadratric: 0,
    },
  },
  testnet: {
    interestModel: {
      default: 0,
      linear: 0,
      tripleSlope: 0,
      quadratric: 0,
    },
  },
}

export type ContractAddress = {
  stabilityFactory: string
  stabilityRouter: string
  oracle: string
  stabilityController: string
  factory: string
  pilotPool: string
  pilotGateway: string
}

export type CodeID = {
  interestModel: {
    default: number
    linear: number
    tripleSlope: number
    quadratric: number
  }
}
